import { useFormContext, useFieldArray } from "react-hook-form";
import { Button } from "@/components/ui/button";
import { PlusIcon } from "@heroicons/react/16/solid";
import { ExceptionsItem } from "./exceptions-item";

export const ExceptionsList = ({ exceptions }) => {
    const { control } = useFormContext();

    const { fields, append, remove } = useFieldArray({
        control,
        name: `Times`,
    });

    const addException = () => {
        append({
            startTime: "",
            endTime: "",
        });
    };

    return (
        <div className="space-y-4">
            {exceptions.length ? (
                <div>
                    <h3 className="mb-2 text-neutral-500">Upcoming</h3>
                    <ul role="list" className="space-y-4">
                        {exceptions.map((exception) => (
                            <li key={exception.id} role="listitem">
                                <ExceptionsItem index={exception.id} />
                            </li>
                        ))}
                    </ul>
                </div>
            ) : (
                ""
            )}
            <div>
                <h3 className="mb-5 text-neutral-500">Add slot</h3>
                {!fields.length && (
                    <p className="mb-5 text-sm text-neutral-600">
                        Add periods of time when you’re unavailable for
                        bookings.
                    </p>
                )}
                <ul role="list" className="space-y-4">
                    {fields.map((field) => (
                        <li key={field.id} role="listitem">
                            <ExceptionsItem
                                index={field.id}
                                isNew={true}
                                onRemove={(index) => remove(index)}
                            />
                        </li>
                    ))}
                </ul>
            </div>
            <Button
                type="button"
                variant="secondary"
                size="sm"
                onClick={addException}
            >
                <PlusIcon />
                Add slot
            </Button>
        </div>
    );
};
